/// <reference path="../../../AppKitchen/typings/AppKitchen.UI.d.ts"/>
/// <reference path="../../typings/EEX.McEc.Api.d.ts"/>

module EEX.McEc.Data.Provider {

    export class CertificateProvider extends AppKitchen.Data.Provider.ProviderBase {

        public load(request: Domain.CertificateRequest): JQueryPromise<Domain.CertificateModel> {
            return this.do("Certificate", request);
        }
    }
}